var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokUsz520V0Xpov(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 176 176",
    fill: "#ff3030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_14.tiktok",
    "data-name": "14.tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "m144.52 173a532.59 532.59 0 0 1 -113 0 32.07 32.07 0 0 1 -28.52-28.48 532.59 532.59 0 0 1 0-113 32.07 32.07 0 0 1 28.48-28.52 532.59 532.59 0 0 1 113 0 32.07 32.07 0 0 1 28.52 28.48 532.59 532.59 0 0 1 0 113 32.07 32.07 0 0 1 -28.48 28.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "m74.73 143a35.1 35.1 0 0 1 0-70.2h8.57v17.13h-8.57a18 18 0 1 0 18 18v-74.93h17.13v8.56a18 18 0 0 0 18 18h8.57v17.1h-8.63a34.72 34.72 0 0 1 -18-5v36.24a35.13 35.13 0 0 1 -35.07 35.1z",
    fill: "#1d1d1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokUsz520V0Xpov);
export default __webpack_public_path__ + "static/media/tiktok_usz520v0xpov.aeaf154f79340358d170c6f3989bc16b.svg";
export { ForwardRef as ReactComponent };